<div class="d-flex flex-column h-100 p-2"  id="seda_car_list">
    <div class="form-inline justify-content-center p-3 border">        
        <div class="form-group">
            <input type="text" class="form-control form-control-sm border-muted"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
        </div>
        <div class="form-group ml-1">
                <button type="button" class="btn btn-sm border-muted"
                (click)="clickSearch()">
                <i class="mdi mdi-magnify"></i>
                <span class="ml-1">차량검색</span>
            </button>
        </div>
    </div>

    <ul class="nav nav-tabs nav-fill mt-3">
        <li class="nav-item">
            <div class="nav-link pointer p-1 text-success"
                [class.active]="selectedStatus === 'all'"
                (click)="clickSelectStatus('all')">
                <div class="small">
                    ALL
                </div>
                <div class="h3">
                    {{carCnt.all}}
                </div>
            </div>
        </li>
        <li class="nav-item">
            <div class="nav-link pointer p-1 text-info"
                [class.active]="selectedStatus === 'on'"
                (click)="clickSelectStatus('on')">
                <div class="small">
                    ON
                </div>
                <div class="h3">
                    {{carCnt.on}}
                </div>
            </div>
        </li>
        <li class="nav-item">
            <div class="nav-link pointer p-1 text-secondary"
                [class.active]="selectedStatus === 'off'"
                (click)="clickSelectStatus('off')">
                <div class="small">
                    OFF
                </div>
                <div class="h3">
                    {{carCnt.off}}
                </div>
            </div>
        </li>
        <li class="nav-item">
            <div class="nav-link pointer p-1 text-danger"
                [class.active]="selectedStatus === 'error'"
                (click)="clickSelectStatus('error')">
                <div class="small">
                    ERROR
                </div>
                <div class="h3">
                    {{carCnt.error}}
                </div>
            </div>
        </li>
    </ul>
    <div class="d-none">{{renderChange}}</div>
    <div class="flex-grow-1 overflow-auto cscrollbar border-top-0 border">
        <ng-container *ngFor="let teamInfo of listTeamInfo;let idx = index;">
            <div class="card mb-0 border-bottom border-left border-right"
                [hidden]="teamInfo.cntCarStatus === 0">
                <ng-container *ngIf="teamInfo.dtgTeamId !== selectedTeamId">
                    <div class="card-header p-2 bg-white pointer"
                        (click)="clickTeamInfo(teamInfo.dtgTeamId,idx,false)">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="" id="team-{{teamInfo.dtgTeamId}}">
                                <i class="mdi mdi-plus"></i>
                                <span class="ml-2">{{teamInfo.dtgTeamNm}}</span>
                            </div>
                            <span class="badge badge-pill badge-secondary">
                                {{teamInfo.cntCarStatus}}
                                /
                                {{teamInfo.cntCar}}
                            </span>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="teamInfo.dtgTeamId === selectedTeamId">
                    <div class="card-header p-2 bg-secondary text-white pointer"
                        (click)="unselectTeamInfo(teamInfo.dtgTeamId,idx,false)">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="" id="team-{{teamInfo.dtgTeamId}}">
                                <i class="mdi mdi-minus"></i>
                                <span class="ml-2">{{teamInfo.dtgTeamNm}}</span>
                            </div>
                            <span class="badge badge-pill badge-light">
                                {{teamInfo.cntCarStatus}}
                                /
                                {{teamInfo.cntCar}}
                            </span>
                        </div>
                    </div>
                </ng-container>
                
                <ul class="list-group list-group-flush" 
                    *ngIf="teamInfo.dtgTeamId === selectedTeamId"
                    [@listAnimation]="teamInfo.dtgTeamId === selectedTeamId">
                    <ng-container *ngFor="let carInfo of listCarInfoFilterdStatus | filterCarTeam:teamInfo.dtgTeamId;">
                        <ng-container *ngIf="!selectedCar || selectedCar.dtgUnitId !== carInfo.dtgUnitId">
                            <li class="list-group-item list-group-item-action p-2 pointer"
                                (click)="clickCarInfo(carInfo)"
                                id="car-{{carInfo.dtgUnitId}}"
                                [class.disabled]="checkLatLng(carInfo) === false">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="text-muted small">
                                        <i class="far fa-clock fa-fw"></i>
                                        <span class="ml-1">
                                            {{carInfo.dtgRegDt | date:'yyyy-MM-dd HH:mm:ss' | filterDateDiffHuman:'yyyy-MM-dd HH:mm:ss' || '-'}}
                                        </span>
                                    </div>
                                    <ng-container *ngIf="carInfo.ownYn === 'N'">
                                        <span class="badge badge-pill badge-warning">
                                            {{carInfo.companyNm}}
                                        </span>
                                    </ng-container>
                                </div>
                                <div class="d-flex align-items-center justify-content-between my-2">
                                    <div>
                                        <icon-power [carInfo]="carInfo"></icon-power>
                                        <icon-gps [dtgGpsStatus]="carInfo.dtgGpsStatus" class="ml-1"></icon-gps>
                                        <icon-alert [val]="carInfo" class="ml-1"></icon-alert>
                                        <icon-network [dtgRssi]="carInfo.dtgRssi" class="ml-1"></icon-network>
                                    </div>
                                    <div class="h5 mb-0 ml-3">{{carInfo.dtgCarNo}}</div>
                                </div>
                                <div class="small text-muted">
                                    <i class="fas fa-map-marker-alt"></i>
                                    <span class="ml-1">
                                        {{carInfo.dtgGpsAddr || '-'}}
                                    </span>
                                </div>
                            </li>
                        </ng-container>
                        <ng-container *ngIf="selectedCar && selectedCar.dtgUnitId === carInfo.dtgUnitId">
                            <li class="list-group-item list-group-item-action p-2 pointer bg-light"
                                (click)="unselectCarInfo(carInfo)"
                                id="car-{{carInfo.dtgUnitId}}"
                                [class.disabled]="checkLatLng(carInfo) === false">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="text-muted small">
                                        <i class="far fa-clock fa-fw"></i>
                                        <span class="ml-1">
                                            {{carInfo.dtgRegDt | date:'yyyy-MM-dd HH:mm:ss' | filterDateDiffHuman:'yyyy-MM-dd HH:mm:ss' || '-'}}
                                        </span>
                                    </div>
                                    <ng-container *ngIf="carInfo.ownYn === 'N'">
                                        <span class="badge badge-pill badge-warning">
                                            {{carInfo.companyNm}}
                                        </span>
                                    </ng-container>
                                </div>
                                <div class="d-flex align-items-center justify-content-between my-2">
                                    <div>
                                        <icon-power [carInfo]="carInfo"></icon-power>
                                        <icon-gps [dtgGpsStatus]="carInfo.dtgGpsStatus" class="ml-1"></icon-gps>
                                        <icon-alert [val]="carInfo" class="ml-1"></icon-alert>
                                        <icon-network [dtgRssi]="carInfo.dtgRssi" class="ml-1"></icon-network>
                                    </div>
                                    <div class="h5 mb-0 ml-3">{{carInfo.dtgCarNo}}</div>
                                </div>
                                <div class="small text-muted">
                                    <i class="fas fa-map-marker-alt"></i>
                                    <span class="ml-1">
                                        {{carInfo.dtgGpsAddr || '-'}}
                                    </span>
                                </div>
                            </li>
                        </ng-container>
                    </ng-container>
                </ul>
            </div>
        </ng-container>
    </div>
</div>
